import type { AiManagedGroupEligibleCampaign } from "@adpilot/shared";
import type {
  CandidateSortDirection,
  CandidateSortField,
} from "@/components/managed-group/ManagedGroupCandidatePicker";

export const CAMPAIGN_PAGE_SIZE = 4;
const DELIVERY_SORT_ORDER = { enabled: 0, paused: 1, archived: 2 } as const;

export function sortCandidates(
  candidates: AiManagedGroupEligibleCampaign[],
  sortBy: CandidateSortField,
  direction: CandidateSortDirection,
): AiManagedGroupEligibleCampaign[] {
  const sign = direction === "asc" ? 1 : -1;
  return candidates.sort((left, right) => {
    const leftPriority =
      sortBy === "aiStatus" ? (left.aiManaged ? 0 : 1) : DELIVERY_SORT_ORDER[left.status];
    const rightPriority =
      sortBy === "aiStatus" ? (right.aiManaged ? 0 : 1) : DELIVERY_SORT_ORDER[right.status];
    return (leftPriority - rightPriority) * sign || left.name.localeCompare(right.name);
  });
}
